export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";